import { TGameCategoryRubricator } from "@/api";

import MethodBuilder from "../method-builder";

export class GameCategoryRubricatorAPI {
  static getAll = new MethodBuilder<
    {},
    { data: TGameCategoryRubricator[]; total: number }
  >()
    .withName("GameCategoryRubricator.getAll")
    .build();
}
